var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var DateFormat = require('../../../components/dateFormat.jsx');
var Tags = require('./tags.jsx');
var Targets = require('./targets.jsx');

var MessageDetail = createReactClass({
    mixins: [PureRenderMixin],

    render: function () {
        return (
            <div className="message-detail">
                <div className="message-detail-header">
                    <h1>{this.props.message.subject.text}</h1>

                    <Tags tagIDs={this.props.message.tags} tags={this.props.tags} />
                </div>
                <div className="message-detail-body">
                    <p className="text">{this.props.message.text}</p>
                    {this.props.message.action.target && <p className="text"><a href={this.props.message.action.target}><img src={this.props.message.action.image} alt="" /></a></p>}
                </div>
                <div className="message-detail-footer">
                    <Targets targetIDs={this.props.message.meta.target} targets={this.props.targets} />
                    <p className="date"><DateFormat date={this.props.message.updatedAt} format="MMM DD YYYY, h:mm:ss a" /></p>
                </div>
            </div>
        );
    }
});

module.exports = MessageDetail;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/layout/messageDetail.jsx